import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      document
          .querySelectorAll( '[data-component="benefits"]' )
          .forEach( ( component ) => {
            const path = component.querySelector(
                '.benefits__squiggle path',
            );

            if ( !path ) return;

            const length = path.getTotalLength();

            gsap.set( path, {
              strokeDasharray: length,
              strokeDashoffset: length,
            } );

            gsap.to( path, {
              strokeDashoffset: 0,
              duration: 2.5,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: component,
                start: 'top 75%',
                once: true,
              },
            } );
          } );
    },

    finalize: function() {},
  };

  app.registerComponent( 'benefits', COMPONENT );
} )( app );
